import { inject, Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import type { IUserDetailed } from '@dev-fast/types';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { UserState } from '@app/core/state/user-store';

@Injectable({
  providedIn: 'root',
})
export class BanActivateGuard {
  readonly #store = inject(Store);

  readonly user$: Observable<IUserDetailed | null | undefined> = this.#store.select(UserState.user);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const path = route.routeConfig && route.routeConfig.path ? route.routeConfig.path : '';

    const allowedPath = ['support', 'account', 'block'];
    return this.user$.pipe(
      map((value) => {
        if (!!value && value.permLock) {
          if (allowedPath.some((el) => path.includes(el))) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }),
    );
  }
}
